import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const reactPlugin = new ReactPlugin();

// Initialize Application Insights
const appInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.REACT_APP_APPLICATIONINSIGHTS_CONNECTION_STRING,
        extensions: [reactPlugin],
        extensionConfig: {
            [reactPlugin.identifier]: { history: browserHistory }
        },
        enableAutoRouteTracking: true,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ['*.linz.govt.nz', 'localhost:5001', 'trailadmin.teararoa.org.nz'],
        enableRequestHeaderTracking: true,
        enableAjaxPerfTracking: true,
        enableUnhandledPromiseRejectionTracking: true
    }
});

// Initialize the instance
appInsights.loadAppInsights();
appInsights.trackPageView();

// Track custom events
export const trackEvent = (name: string, properties?: { [key: string]: any }) => {
    appInsights.trackEvent({ name }, properties);
};

// Track exceptions
export const trackException = (error: Error, properties?: { [key: string]: any }) => {
    appInsights.trackException({ error, severityLevel: 3 }, properties);
};

// Track page views
export const trackPageView = (name?: string, uri?: string) => {
    appInsights.trackPageView({ name, uri });
};

// Track metrics
export const trackMetric = (name: string, average: number, properties?: { [key: string]: any }) => {
    appInsights.trackMetric({ name, average }, properties);
};

export default appInsights; 